import Tag from 'common/types/Tag';

export default function getTagsByCategory(tags: Tag[], category: string) {
  return tags.filter((tag) => tag.category === category);
}
